<template>
  <section v-on:click="sectionClicked">
    <Header :class="{scrolled: isScrolled}" ref="header"
      menu="blog"/>
    <div class="blog">
      <div class="cnt">
        <div class="blogHeader">Blog</div>
        <div class="blogCnt">
          <div class="blogCntHeader">
            <div class="sortBy">
              Team Up For
            </div>
            <div class="viewType">
              <div class="viewTypeItem list" v-on:click="selectViewType('list')"
                :class="{active: viewType === 'list'}"></div>
              <div class="viewTypeItem grid" v-on:click="selectViewType('grid')"
                :class="{active: viewType === 'grid'}"></div>
            </div>
          </div>
          <div class="theBlog blogLoading" v-if="loading"
            :class="{grid: viewType === 'grid'}">
            <div class="blogItem" v-for="i in 3" :key="i">
              <div class="blogImg"></div>
              <div class="blogInfo">
                <div class="timestamp"></div>
                <h4></h4>
                <p></p>
              </div>
            </div>
          </div>
          <div class="notFound" v-else-if="!loading && blogPosts.length < 1"></div>
          <div class="theBlog" :class="{grid: viewType === 'grid'}" v-else>
            <a class="blogItem" v-for="(post, i) in blogPosts" :key="i"
              :href="post.url" target="_blank">
              <div class="blogImg hasImg" v-if="post.imageUrl"
                :style="{'background-image': `url(${post.imageUrl})`}"></div>
              <div class="blogImg noImg" v-else></div>
              <div class="blogInfo">
                <div class="timestamp">
                  {{post.publishDate | moment('dddd, D MMM YYYY')}}
                  &bull;
                  <span v-if="post.blogger && post.blogger.domain">
                    {{post.blogger.domain}}
                  </span>
                </div>
                <h4>{{post.title}}</h4>
                <p>{{post.summary.substr(0, 180)}}...</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';

export default {
  name: 'home',
  components: { Header },
  data() {
    return {
      isScrolled: false,
      viewType: 'list',
      loading: true,
      blogPosts: [],
    };
  },
  created() {
    document.addEventListener('scroll', this.scrolled);
  },
  destroyed() {
    document.removeEventListener('scroll', this.scrolled);
  },
  computed: {},
  methods: {
    doNothing() {},
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.sectionClicked();
    },
    scrolled() {
      this.isScrolled = window.scrollY > 30;
    },
    selectViewType(viewType) {
      this.viewType = viewType;
      localStorage.setItem('viewType', viewType);
    },
    getData() {
      this.loading = true;
      this.$http.get(this.$config.uri('blog/posts')).then((r) => {
        this.blogPosts = (r.data.status === 200) ? r.data.data : [];
        this.loading = false;
      });
    },

    /**
     * Analytic
     *
     */
    fireAlEvent(convId) {
      this.$emit('fireal', 'page_visit', 'blog', null, convId, (r) => {
        if (r.data.status !== 200) return;
        alTimer = setTimeout(() => {
          this.fireAlEvent(r.data.id);
        }, 5000);
      });
    },
  },
  beforeDestroy() {
    if (alTimer) clearTimeout(alTimer);
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Blog - Team Up For Impact';
    this.viewType = localStorage.getItem('viewType') || 'list';
    this.getData();

    this.fireAlEvent();
  },
};
</script>

<style scoped lang="scss">
.blog{
  padding-top: 120px;
  @media (max-width: 960px) {
    padding-top: 60px;
  }
}
.blogHeader{
  height: 300px;
  background-color: #5351a4;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 46px;
  font-family: 'GolosUIWebBold', sans-serif;
  @media (max-width: 1180px) {
    height: 26vw;
  }
  @media (max-width: 960px) {
    margin: 0 -16px;
  }
  @media (max-width: 680px) {
    height: 40vw;
  }
}
.blogCnt{
  max-width: 960px;
  margin: 0 auto;
  padding: 40px 0 0;
  @media (max-width: 860px) {
    padding-top: 20px;
  }
  .blogCntHeader{
    display: flex;
    border-bottom: #eee 1px solid;
    padding: 0 0 20px;
    margin-bottom: 20px;
    .sortBy{
      padding: 10px 14px 8px;
      text-transform: uppercase;
      font-weight: bold;
      border: #5351a4 1px solid;
      color: #5351a4;
      border-radius: 3px;
      width: 180px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      position: relative;
      cursor: pointer;
      transition: all .3s ease;
      margin-right: auto;
      visibility: hidden;
      &:before{
        content: "";
        position: absolute;
        right: 14px; top: 0; bottom: 0;
        width: 14px;
        background-image: url(../assets/arrow-down-dd.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
      }
      &:hover{
        background-color: #5351a4;
        color: #fff;
        &:before{
          background-image: url(../assets/arrow-down-dd-white.png);
        }
      }
    }
    .viewType{
      display: flex;
      border-radius: 3px;
      overflow: hidden;
      .viewTypeItem{
        width: 40px;
        transition: all .3s ease;
        cursor: pointer;
        background-size: 22px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .45;
        &:hover{
          background-color: #eee;
        }
        &.list{
          border: #5351a4 1px solid;
          border-radius: 3px 0 0 3px;
          background-image: url(../assets/list.png);
          background-size: 27px;
        }
        &.grid{
          border: #5351a4 1px solid;
          border-left: none;
          border-radius: 0 3px 3px 0;
          background-image: url(../assets/grid.png);
        }
        &.active{
          opacity: 1;
        }
      }
    }
  }
  .theBlog{
    transition: all .3s ease;
    .blogItem{
      position: relative;
      min-height: 200px;
      margin-bottom: 20px;
      padding-bottom: 20px;
      border-bottom: #eee 1px solid;
      transition: all .3s ease;
      display: block;
      color: #767676;
      @media (max-width: 860px) {
        min-height: 160px;
      }
      .blogImg{
        position: absolute;
        left: 0; top: 0;
        width: 200px; height: 200px;
        background-color: #eee;
        transition: all .3s ease;
        background-position: center;
        background-size: cover;
        @media (max-width: 860px) {
          width: 160px; height: 160px;
        }
        @media (max-width: 680px) {
          width: 100px; height: 100px;
        }
        &.noImg{
          &:before{
            position: absolute; content: "";
            left: 0; top: 0; right: 0; bottom: 0;
            background-image: url(../assets/image-black.png);
            background-size: 46px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
        }
      }
      .blogInfo{
        padding-left: 226px;
        transition: all .3s ease;
        @media (max-width: 860px) {
          padding-left: 186px;
        }
        @media (max-width: 680px) {
          padding-left: 116px;
        }
        .timestamp{
          transition: all .3s ease;
          text-transform: uppercase;
          color: #767676;
          font-size: 12px;
          padding-top: 10px;
          margin: 0 0 10px;
          @media (max-width: 680px) {
            font-size: 10px;
            margin: 0 0 4px;
            padding: 0;
          }
        }
        h4{
          margin: 0 0 10px;
          line-height: 1.3;
          font-size: 22px;
          transition: all .3s ease;
          color: #444;
          @media (max-width: 860px) {
            font-size: 20px;
          }
          @media (max-width: 680px) {
            font-size: 15px;
            margin: 0 0 6px;
          }
        }
        p{
          margin: 0;
          @media (max-width: 680px) {
            font-size: 13px;
          }
        }
      }
    }
    &.grid{
      display: flex;
      flex-wrap: wrap;
      margin: 0 -10px;
      .blogItem{
        width: 33.33333333%;
        padding: 0 10px;
        box-sizing: border-box;
        border: none;
        margin: 0 0 40px;
        @media (max-width: 960px) {
          padding: 0 8px;
        }
        @media (max-width: 680px) {
          width: 50%;
          margin-bottom: 20px;
        }
        .blogImg{
          position: relative;
          width: 100%;
          height: 280px;
          left: auto; right: auto;
          bottom: auto; top: auto;
          @media (max-width: 1024px) {
            height: 26vw;
          }
          @media (max-width: 680px) {
            height: 30vw;
          }
        }
        .blogInfo{
          padding: 0;
          .timestamp{
            padding: 14px 0 4px;
            margin: 0;
            @media (max-width: 860px) {
              font-size: 10px;
            }
          }
          h4{
            font-size: 20px;
            font-family: 'GolosUIWebBold', sans-serif;
            @media (max-width: 960px) {
              font-size: 18px;
            }
            @media (max-width: 860px) {
              font-size: 16px;
            }
            @media (max-width: 680px) {
              font-size: 14px;
            }
          }
          p{
            display: none;
          }
        }
      }
    }
    &.blogLoading{
      .blogItem{
        .blogImg{
          background-color: #eee;
        }
        .timestamp{
          background-color: #eee;
          height: 10px; width: 100px;
        }
        h4{
          background-color: #eee;
          height: 40px;
        }
        p{
          background-color: #eee;
          height: 20px; width: 80%;
        }
      }
      &.grid{
        .blogItem{
          .blogImg{
            margin-bottom: 10px;
          }
          .timestamp{
            margin-bottom: 10px;
            height: 20px;
            padding: 0;
          }
          h4{
            height: 30px;
          }
        }
      }
    }
  }
}
</style>
